import React from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import Events from "src/routes/event/Events";
import EventView from "src/routes/event/EventView";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
export default function EventProper_Index(props) {
  var id = useURLParam('id');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Events"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: [{
      id: "list",
      label: "Events",
      icon: "calendar",
      content: /*#__PURE__*/React.createElement(Events, null),
      queryString: {
        id: undefined
      }
    }, {
      id: "view",
      label: "View",
      icon: "eye",
      content: /*#__PURE__*/React.createElement(EventView, null),
      show: id !== null
    }]
  }));
}

// @ts-ignore